const INTERNAL_ROUTER = Symbol.for('internal-router');

export { INTERNAL_ROUTER };
